import React, { useEffect, useRef, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import dayjs from 'dayjs';

L.Icon.Default.mergeOptions({
  iconRetinaUrl: '/images/leaflet/marker-icon-2x.png',
  iconUrl: '/images/leaflet/marker-icon.png',
  shadowUrl: '/images/leaflet/marker-shadow.png',
});


// Optional: Custom vehicle icon
const liveVehicleIcon = L.icon({
  iconUrl: '/images/leaflet/live-car.png', // Use your preferred live icon here
  iconSize: [45, 45],
  iconAnchor: [22.5, 45],
  popupAnchor: [0, -45]
});

const RecenterMap = ({ lat, lng }) => {
  const map = useMap();
  useEffect(() => {
    map.setView([lat, lng], map.getZoom(), { animate: true });
  }, [lat, lng]);
  return null;
};

function LiveLocation({ fguid, vehicle }) {
  const [position, setPosition] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [isTracking, setIsTracking] = useState(false);
  const [intervalId, setIntervalId] = useState(null);

  const url = "https://icloud.assetscontrols.com:3443/OpenApi/LBS";
  const payload = {
    FAction: "QueryLBSMonitorListByFGUIDs",
    FTokenID: "3585535a-137c-499e-82ad-af9feff7d8e7",
    FGUIDs: fguid,
    FType: 2
  };

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjIiLCJyb2xlX2lkIjoiMiIsImlhdCI6MTc0Mzg0MzcyMSwiZXhwIjoxNzQ0NzA3NzIxfQ.fup5ZE8Wq0bXR6i386-rrpTl75scTeeaeBRE15HK8l4'
  };

  const fetchPosition = () => {
    fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(data => {
        if (data.Result === 200 && data.FObject && data.FObject.length > 0) {
          const gpsData = data.FObject[0];
          const lat = parseFloat(gpsData.FLatitude);
          const lng = parseFloat(gpsData.FLongitude);
          const timestamp = gpsData.FGPSTime;

          if (!isNaN(lat) && !isNaN(lng)) {
            setPosition({ lat, lng });
            setLastUpdate(timestamp);
          }
        }
      })
      .catch(err => {
        console.error('Failed to fetch GPS data:', err.message);
      });
  };

  const startTracking = () => {
    if (!isTracking) {
      fetchPosition();
      const id = setInterval(fetchPosition, 2000);
      setIntervalId(id);
      setIsTracking(true);
    }
  };

  const stopTracking = () => {
    if (isTracking && intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
      setIsTracking(false);
    }
  };

  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [intervalId]);

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center bg-white px-4 py-3 rounded-lg shadow">
        <h2 className="text-xl font-bold text-gray-800">
          Live Vehicle Location — <span className="text-blue-600">{vehicle}</span>
        </h2>
        <div className="space-x-2">
          {isTracking ? (
            <button onClick={stopTracking} className="moButtons bg-red-500 text-white px-4 py-1.5 rounded shadow hover:bg-red-600 transition">
              Stop Tracking
            </button>
          ) : (
            <button onClick={startTracking} className="moButtons bg-green-500 text-white px-4 py-1.5 rounded shadow hover:bg-green-600 transition">
              Start Tracking
            </button>
          )}
        </div>
      </div>

      <div className="h-[500px] w-full rounded-lg overflow-hidden shadow">
        {position ? (
          <MapContainer
            center={[position.lat, position.lng]}
            zoom={15}
            scrollWheelZoom={true}
            className="h-full w-full"
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; OpenStreetMap contributors'
            />
            <Marker position={[position.lat, position.lng]} icon={liveVehicleIcon}>
              <Popup>
                <div className="space-y-1 text-sm">
                  <p><strong>{vehicle}</strong></p>
                  <p>Lat: {position.lat.toFixed(5)}</p>
                  <p>Lng: {position.lng.toFixed(5)}</p>
                  {lastUpdate && (
                    <p>Last update: {dayjs(lastUpdate).format('YYYY-MM-DD HH:mm:ss')}</p>
                  )}
                </div>
              </Popup>
            </Marker>
            <RecenterMap lat={position.lat} lng={position.lng} />
          </MapContainer>
        ) : (
          <div className="flex items-center justify-center h-full text-gray-500 bg-gray-50 rounded-lg">
            {isTracking ? 'Fetching live location...' : 'Start tracking to see location'}
          </div>
        )}
      </div>
    </div>
  );
}

export default LiveLocation;
